/** Font family with the flag emojis only, loaded where the system has none (Windows); see `polyfillFlagEmojis`. */
export const FLAG_EMOJI_FONT = 'Twemoji Country Flags';
